<template>
    <div class="bet notranslate" v-bind:class="{ rejected: bet.isWaitingReject, live: bet.isLive }">
        <BetOptionInfo v-bind:bet="bet" />
        <BetDetail v-bind:bet="bet" />
    </div>
</template>

<script lang="ts" setup>
    import type { PropType } from 'vue';
    import BetDetail from '@/components/myBets/miniMyBets/BetDetail.vue';
    import BetOptionInfo from '@/components/myBets/miniMyBets/BetOptionInfo.vue';
    import type { IBet } from '@/interface/IBet';

    defineProps({
        bet: {
            type: Object as PropType<IBet>,
            required: true,
        },
    });
</script>

<style lang="scss" scoped>
    @import "@/components/myBets/miniMyBets/Bet";
</style>
